module.exports = __webpack_public_path__ + "img/skillsbg2.cf49e011.jpg";